import { useAuth } from '@frontegg/react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { SETTINGS } from '@elementary/common-ui/constants/queryKeys';
import dayjs from 'dayjs';
import { SetAccountSettingsApi } from 'shared/types';
import * as api from '../services/settingsApi';
import useSnackbar from './useSnackbar';

const useAccountSettings = () => {
  const { isAuthenticated } = useAuth();
  const { openSnackbar } = useSnackbar();
  const { data, isLoading, refetch } = useQuery(
    [SETTINGS],
    async () => {
      const settings = await api.fetchAccountSettings();
      const tz = settings?.timezone || undefined;
      dayjs.tz.setDefault(tz);
      return settings;
    },
    {
      enabled: isAuthenticated,
    },
  );
  const { mutate: update, isLoading: isUpdating } = useMutation(
    (mutateData: SetAccountSettingsApi) =>
      api.updateAccountSettings(mutateData),
    {
      onSuccess: () => {
        openSnackbar({ message: 'Settings updated successfully.' });
        refetch();
      },
    },
  );

  return {
    data,
    update,
    isLoading,
    isUpdating,
  };
};

export default useAccountSettings;
